import { ReactElement } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';

import { Main } from 'main';
import { AuthError } from 'pages/AuthError';
import { routes } from 'routes';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';

/**
 * Auth0 currently redirects failed logins to the app root with `error` +
 * `state` query params. Forward those to the public /auth-error page before
 * the protected tree mounts — `withAuthenticationRequired` would otherwise
 * bounce the user straight back to Auth0 and loop forever. Can be removed
 * once the Auth0 Action redirects to /auth-error directly.
 */
const CatchAuthError = ({ children }: { children: ReactElement }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  if (params.has('error') && params.has('state')) {
    return <Navigate to={{ pathname: routes.authError, search }} replace />;
  }

  return children;
};

export const App = () => (
  <Router>
    <Routes>
      <Route path={routes.authError} element={<AuthError />} />
      <Route
        path="*"
        element={
          <CatchAuthError>
            <Main />
          </CatchAuthError>
        }
      />
    </Routes>
  </Router>
);
